import { useSelector } from "react-redux";
import { useIntl } from 'react-intl';
import { Autocomplete } from '@mantine/core';

const FilterComponent = ({ setFilter, filter }) => {
  const intl = useIntl();
  const { categories } = useSelector((state) => state.options);
  
  return (
    <Autocomplete
      placeholder={intl.formatMessage({ id: "userInput.filter.category" })}
      data={categories.map(category => category.categoryName)}
      value={filter.category || ''}
      onChange={(value) => {
        const selectedCategory = categories.find(cat => cat.categoryName === value);
        setFilter(prev => ({
          ...prev,
          category: value,
          UPC: selectedCategory?.id || ''
        }));
      }}
      maxDropdownHeight={200}
      sx={{
        width: '100%',
        '.mantine-Autocomplete-dropdown': {
          maxHeight: '200px',
          height: 'auto',
        },
        '.mantine-Autocomplete-item': {
          whiteSpace: 'nowrap',
        },
      }}
    />
  );
};

export default FilterComponent;